/* unplugin-vue-components disabled */import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import "./Register.vue?vue&type=style&index=0&id=136ee7a2&lang=less"

const __exports__ = script;

export default __exports__